<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'findingreport.linkedFindingReport.cardTitle' | transloco }}</div>
    <div class="detail-page-card-actions">
        @if (showOpenButton && detailsModel) {
            <button class="btn btn-raised" (click)="openFindingReport()">
                <i class="fas fa-external-link-alt"></i>
                <span>{{ 'findingreport.linkedFindingReport.openBtn' | transloco }}</span>
            </button>
        }
    </div>
    <div class="detail-page-card-body padded form-group-styling">
        <div class="row">
            @if (detailsModel) {
                <div class="col-xl-6 left-block">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>{{ 'findingreport.linkedFindingReport.reportNameLabel' | transloco }}</label>
                                <input
                                    type="text"
                                    [value]="detailsModel.name"
                                    class="form-control form-control-sm"
                                    disabled
                                    inputTooltip
                                />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>{{ 'findingreport.linkedFindingReport.reportTypeLabel' | transloco }}</label>
                                <input
                                    type="text"
                                    [value]="detailsModel.reportTypeName"
                                    class="form-control form-control-sm"
                                    disabled
                                    inputTooltip
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>{{ 'findingreport.linkedFindingReport.reportNoLabel' | transloco }}</label>
                                <input
                                    type="text"
                                    [value]="detailsModel.reportNumber"
                                    class="form-control form-control-sm"
                                    disabled
                                    inputTooltip
                                />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>{{ 'findingreport.linkedFindingReport.overallScoreLabel' | transloco }}</label>
                                <ng-select
                                    [items]="[
                                        {
                                            value: detailsModel.overallScoreId,
                                            label: detailsModel.overallScoreName,
                                            color: detailsModel.overallScoreColor,
                                        },
                                    ]"
                                    [ngModel]="detailsModel.overallScoreId"
                                    bindValue="value"
                                    disabled
                                >
                                    <ng-template ng-label-tmp ng-option-tmp let-item="item">
                                        <span
                                            class="select-template-color"
                                            [style.background-color]="item.color"
                                        ></span>
                                        {{ item.label }}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label>{{ 'findingreport.linkedFindingReport.reportDateLabel' | transloco }}</label>
                                <date-input
                                    [(value)]="detailsModel.reportDate"
                                    [disabled]="true"
                                ></date-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 right-block">
                    <div class="form-group">
                        <label>{{ 'findingreport.linkedFindingReport.conclusionLabel' | transloco }}</label>
                        <textarea
                            type="date"
                            [value]="detailsModel.conclusion"
                            class="form-control form-control-sm"
                            disabled
                            inputTooltip
                        >
                        </textarea>
                    </div>
                </div>
            } @else {
                <div class="fancy-loader submodule"></div>
            }
        </div>
    </div>
</div>
